import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'pcm-data-form-field-boolean',
	templateUrl: './data-form-field-boolean.component.html',
	styleUrls: ['./data-form-field-boolean.component.scss']
})
export class DataFormFieldBooleanComponent {
	@Input() propName: string;
	@Input() name: string;
	@Input() formGroup: UntypedFormGroup;
	// helpMessage will only be displayed with 'radio' type
	@Input() helpMessage: string;
	@Input() invalid = false;
	@Input() invalidText: string;
	// required indicator will only be displayed with 'radio' type
	@Input() required = false;
	// use a checkbox type of boolean control, or two radio buttons
	@Input() type: 'checkbox' | 'radio' = 'checkbox';
	@Input() labelTrue = 'True';
	@Input() labelFalse = 'False';
}
